<div class="container-fluid">

  <!--  <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb> -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>
        <span class="breadcrumb m-0">
          <button class="btn btn-primary d-flex align-items-center" (click)="exportAll()">
            <span class="fas fa-file-excel"> </span> &nbsp;Export All to Excel
          </button>

        </span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <ng-template #template let-anchor>
            <span>{{ anchor.nativeElement.innerText }}</span>
          </ng-template>

          <div kendoTooltip showOn="none" [tooltipTemplate]="template" filter=".k-grid td"
            (mouseover)="showTooltip($event)">
            <kendo-grid [data]="paymentLinkgridData" [reorderable]="true" scrollable="scrollable" [resizable]="true"
              [pageable]="{
                                      buttonCount: buttonCount,
                                      info: info,
                                      type: type,
                                      pageSizes: pageSizes,
                                      previousNext: billpreviousNext
                                    }" [pageSize]="pageSize" [sortable]="true" [selectable]="selectableSettings"
              filterable="menu" [columnMenu]="{ filter: true }" [filter]="billsInvoice.filter"
              [skip]="billsInvoice.skip" [sort]="billsInvoice.sort" (filterChange)="onInvoiceFilterChange($event)"
              (sortChange)="onSortChange($event)" [resizable]="true" scrollable="scrollable"
              (pageChange)="invoicePageChange($event)" (dataStateChange)="invoicetateChange($event)"
              (selectionChange)="invoiceSelectforBillSetting($event)">

              <ng-template kendoGridToolbarTemplate>
                <!-- <kendo-textbox [style.width.px]="250" placeholder="Search in all columns..."
                  [(ngModel)]="invoicesearchedValue" (valueChange)="onFilter($event)"></kendo-textbox> -->
                <div class="search_icon">
                  <kendo-textbox [style.width.px]="250" [style.height.px]="35" [clearButton]="true"
                    (valueChange)="onValueChange($event)" (keyup.enter)="onSearchInvoicesAds()" [style.height.px]="35"
                    [(ngModel)]="invoicesearchedValue" placeholder="Search in all columns...">
                  </kendo-textbox>

                  <button class="btn btn-primary btn-md border-left-none" (click)="onFilter($event)">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
                <kendo-grid-spacer></kendo-grid-spacer>
                <button class="btn  btn-outline-primary btn-sm" (click)="opemInvoiceModel(addAdvertismentModal)">Add New
                  Payment Links
                </button>
                <button class="btn btn-outline-primary btn-sm d-flex align-items-center" (click)="onExport('Excel')">
                  <span class="fas fa-file-excel"></span> &nbsp; Export to Excel
                </button>

              </ng-template>

              <kendo-grid-checkbox-column [columnMenu]="false" [showSelectAll]="true" [width]="40"
                class="no-tooltip"></kendo-grid-checkbox-column>
              <kendo-grid-column field="consumerName" title="Consumer Name"></kendo-grid-column>

              <kendo-grid-column field="phoneNo" title="Mobile Number"></kendo-grid-column>

              <kendo-grid-column field="email" title="Email"></kendo-grid-column>

              <kendo-grid-column field="amount" title="Amount" filter="numeric" format="{0:n2}">
                <ng-template kendoGridCellTemplate let-dataItem>
                  ₹{{ dataItem.amount | number:'1.2-2' }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="flatNo" title="Flat No"></kendo-grid-column>

              <kendo-grid-column field="paymentLink" title="Payment Link" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <a [href]="dataItem.paymentLink" target="_blank">{{ dataItem.paymentLink }}</a>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="paymentId" title="Payment ID"></kendo-grid-column>
              <kendo-grid-column field="createdOn" title="Generated Date" filter="date">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <ng-container *ngIf="dataItem.createdOn; else noDate">
                    {{ dataItem.createdOn | date: 'dd MMM yyyy, hh:mm a' }}
                  </ng-container>
                  <ng-template #noDate>-</ng-template>
                </ng-template>
                <!-- <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.createdOn | date: 'dd MMM yyyy, hh:mm a' }}
                </ng-template> -->
              </kendo-grid-column>
              <kendo-grid-column field="orderId" title="Order ID"></kendo-grid-column>

              <kendo-grid-column field="paymentLinkId" title="Payment Link ID" [hidden]="true"></kendo-grid-column>
              <!--  <kendo-grid-column field="paymentDate" title="Payment Date" filter="date">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.paymentDate | date: 'dd MMM yyyy, hh:mm a' }}
                  
                </ng-template>
               
              </kendo-grid-column> -->
              <kendo-grid-column field="paymentDate" title="Payment Date" filter="date">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.paymentDate ? (dataItem.paymentDate | date: 'dd MMM yyyy, hh:mm a') : '-' }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="paymentLinkExpDate" title="Payment Link Expiry Date" filter="date">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <ng-container *ngIf="dataItem.paymentLinkExpDate; else noDate">
                    {{ dataItem.paymentLinkExpDate | date: 'dd MMM yyyy, hh:mm a' }}
                  </ng-container>
                  <ng-template #noDate>-</ng-template>
                </ng-template>
                <!-- <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.paymentLinkExpDate ? (dataItem.paymentLinkExpDate | date: 'dd MMM yyyy, hh:mm a') : '-' }}
                </ng-template> -->
              </kendo-grid-column>

              <kendo-grid-column field="paymentStatus" title="Payment Status">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span [ngClass]="{
                        'text-success': dataItem.paymentStatus === 'Paid',
                        'text-danger': dataItem.paymentStatus !== 'Paid'
                      }">
                    {{ dataItem.paymentStatus }}
                  </span>
                </ng-template>
              </kendo-grid-column>

            </kendo-grid>
          </div>

          <div style="position: absolute; top: 0; left: -10000px; width: 500px;">
            <kendo-grid [kendoGridBinding]="mySelection.length>0 ? mySelection : paymentLinkgridData.data" #pdfGrid>
              <kendo-grid-column field="consumerName" title="Consumer Name"></kendo-grid-column>

              <kendo-grid-column field="phoneNo" title="Mobile Number"></kendo-grid-column>

              <kendo-grid-column field="email" title="Email"></kendo-grid-column>

              <kendo-grid-column field="amount" title="Amount" filter="numeric" format="{0:n2}">
                <ng-template kendoGridCellTemplate let-dataItem>
                  ₹{{ dataItem.amount | number:'1.2-2' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="flatNo" title="Flat No"></kendo-grid-column>
              <kendo-grid-column field="paymentLink" title="Payment Link">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <a [href]="dataItem.paymentLink" target="_blank">{{ dataItem.paymentLink }}</a>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="paymentId" title="Payment ID"></kendo-grid-column>
              <kendo-grid-column field="createdOn" title="Generated Date"></kendo-grid-column>

              <kendo-grid-column field="orderId" title="Order ID"></kendo-grid-column>

              <kendo-grid-column field="paymentLinkId" title="Payment Link ID"></kendo-grid-column>
              <kendo-grid-column field="payment_Date" title="Payment Date" filter="date">

              </kendo-grid-column>
              <kendo-grid-column field="paymentLink_ExpDate" title="Payment Link Expiry Date" filter="date">

              </kendo-grid-column>


              <kendo-grid-column field="paymentStatus" title="Payment Status">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <span [ngClass]="{
                      'text-success': dataItem.paymentStatus === 'Paid',
                      'text-danger': dataItem.paymentStatus !== 'Paid'
                    }">
                    {{ dataItem.paymentStatus }}
                  </span>
                </ng-template>
              </kendo-grid-column>

              <!-- <kendo-grid-column field="fileUrl" title="Image"></kendo-grid-column> -->
              <kendo-grid-pdf fileName="invoice.pdf" [allPages]="true" paperSize="A4"
                [landscape]="true"></kendo-grid-pdf>
              <kendo-grid-excel fileName="paymentlinks.xlsx"></kendo-grid-excel>
            </kendo-grid>

          </div>

        </div>
      </div>
    </div>
  </div>


</div>

<!-- Add Advertisment modal -->
<ng-template #addAdvertismentModal>
  <div class="modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        @if(invoiceId){<h5 class="modal-title"> Edit Payment Links</h5>}
        @else {<h5 class="modal-title">Generate new Payment Links</h5>}
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeModel()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <form [formGroup]="addpaymentLinkForm">

            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="row">
                <div class="mb-3 col-lg-12">
                  <label>Select Consumers <span class="required">*</span></label>
                  <ng-select [items]="consumerList" bindLabel="name" bindValue="id" formControlName="consumerId"
                    (change)="selectionUser($event)" id="projectId" [multiple]="false" placeholder="Select consumer"
                    [deselectOnClick]="true"></ng-select>

                  @if(individualbillSubmitted && addPaymentlinksFormControls['consumerId'].errors){
                  <div class="invalid-feedback">
                    @if(addPaymentlinksFormControls['consumerId'].errors['required']){
                    <div>{{PaymentLinksValidations.paymentLinks.consumerId}}</div>}
                  </div>}
                </div>

                <div class="mb-3 col-lg-12  col-md-12 col-lg-12">
                  <div class="mb-3">
                    <label for="basicpill-lastname-input">Contact Number </label>
                    <input type="textarea" class="form-control" [disabled]="true" formControlName="contactNumber"
                      id="contactNumber" id="" placeholder="Phone Number">

                  </div>
                </div>
                <div class="mb-3 col-lg-12  col-md-12 col-lg-12">
                  <div class="mb-3">
                    <label for="basicpill-lastname-input">Email </label>
                    <input type="textarea" class="form-control" formControlName="email" id="email" id=""
                      placeholder="Email">

                  </div>
                </div>

                <div class="mb-3 col-lg-12  col-md-12 col-lg-12">
                  <!-- <div class="mb-3">
                  <label for="basicpill-lastname-input">Flat No</label>
                  <input type="textarea" class="form-control" formControlName="flatNo" id="flatNo"
                    id="" placeholder="Flat No">
                
              </div> -->


                  <div class="mb-3">
                    <label for="basicpill-declaration-input">Flat No</label>
                    <ng-select [items]="flatList" formControlName="flatNo" bindLabel="flatNo" [multiple]="false"
                      [deselectOnClick]="true"></ng-select>
                    
                  </div>
                </div>

                <div class="mb-3 col-lg-12  col-md-12 col-lg-12">
                  <div class="mb-3">
                    <label for="basicpill-lastname-input">Recharge Amount <span class="required">*</span></label>
                    <input type="text" class="form-control" min="1" formControlName="rechargeamt" id="rechargeamt"
                      id="" placeholder="Recharge amount">

                    @if((individualbillSubmitted || addPaymentlinksFormControls['rechargeamt'].touched)&&
                    addPaymentlinksFormControls['rechargeamt'].errors){
                    <div class="invalid-feedback">
                      @if(addPaymentlinksFormControls['rechargeamt'].errors['required']){
                      <div>{{PaymentLinksValidations.paymentLinks.rechargeamt}}</div>
                      }
                      @if(addPaymentlinksFormControls['rechargeamt'].errors['min']){
                      <div>Your minimum recharge amount is set to ₹{{min_amount}}</div>
                      }
                      @if(addPaymentlinksFormControls['rechargeamt'].errors['max']){
                      <div> Your maximum recharge amount is set to ₹{{max_amount}}</div>
                      }
                        @if(addPaymentlinksFormControls['rechargeamt'].errors['pattern']){
                        <div>{{PaymentLinksValidations.paymentLinks.Onlynumberwithdecimals}}</div>}

                    </div>}

                  </div>
                </div>
              </div>
            </div>
          </form>

        </div>
      </div>

    </div>
    <div class="modal-footer">
      <!-- <button type="button" class="btn btn-secondary waves-effect" data-bs-dismiss="modal" >Close</button> -->
      @if(invoiceId){<button type="button" [disabled]="isUploading" class="btn btn-primary waves-effect waves-light"
        (click)="sendPaymentLink('update')">update</button>}
      @else{ <button type="button" [disabled]="isUploading" class="btn btn-primary waves-effect waves-light"
        (click)="sendPaymentLink('Create')">Save</button>
      }
    </div>

  </div><!-- /.modal -->

</ng-template>
<!-- Add Advertisment modal End  -->
<!-- Add Advertisment modal End  -->